// src/pages/PaymentCheckout.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axiosInstance";
import { toast } from "react-hot-toast";

// const BACKEND_URL = "http://localhost:8081";
// const BACKEND_URL = "https://api.rangpurgolf.com";

const PaymentCheckout = () => {
  const [paymentGateway, setPaymentGateway] = useState("bkash");
  const [processing, setProcessing] = useState(false);
  const navigate = useNavigate();

  const paymentGatwayList = [
    {
      value: "bkash",
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1759031312/BKash-Icon-Logo.wine_wuvxp8.png",
      label: "bKash",
    },
  ];

  const handlePayment = async () => {
    setProcessing(true);
    try {
      const userEmail = localStorage.getItem("memberEmail");
      if (!userEmail)
        throw new Error("User email not found. Please log in again.");

      // 🔹 Call your backend fake payment API
      await api.post(`/payment/${userEmail}`);

      toast.success("Payment successful!");

      // 🔹 Fetch the latest profile to confirm dashboard unlock
      const profileRes = await api.get(`/profile`);
      const updatedMember = profileRes.data.member;

      // 🔹 Update localStorage based on backend truth
      localStorage.setItem("dashboardLocked", updatedMember.dashboardLocked);
      localStorage.setItem("paymentStatus", updatedMember.paymentStatus);
      localStorage.setItem(
        "registrationStatus",
        updatedMember.registrationStatus
      );

      // ✅ Redirect to dashboard
      navigate("/dashboard");
    } catch (error) {
      console.error("Payment error:", error);
      toast.error(
        error.response?.data?.message || "Payment failed. Please try again."
      );
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="pt-20 px-5 sm:px-10 md:px-44 lg:px-60 min-h-screen bg-gray-50">
      <div className="lg:grid grid-cols-3 lg:gap-9">
        {/* Left Section */}
        <div className="col-span-2 space-y-5 mb-6 lg:mb-0">
          <h1 className="font-semibold text-2xl text-gray-800">
            Complete Your Membership Payment
          </h1>
          <p className="text-gray-600">
            Final step to activate your membership and unlock all dashboard
            features.
          </p>

          <div className="bg-white p-6 rounded-lg shadow-sm">
            <h3 className="text-lg font-semibold text-gray-800 mb-4">
              Payment Summary
            </h3>
            <div className="space-y-3">
              <div className="flex justify-between">
                <span className="text-gray-600">
                  Membership Registration Fee
                </span>
                <span className="font-semibold">৳1,200.00</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">Tax (10%)</span>
                <span className="font-semibold">৳120.00</span>
              </div>
              <hr />
              <div className="flex justify-between text-lg font-bold text-green-700">
                <span>Total Amount</span>
                <span>৳1,320.00</span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div>
          <div className="space-y-3 border bg-white p-5 rounded-md mb-4 shadow-sm">
            <h1 className="text-green-700 font-medium pb-2 text-center text-lg">
              Select Payment Method
            </h1>

            <div className="flex justify-center">
              {paymentGatwayList.map((item, index) => (
                <label
                  key={index}
                  className={`cursor-pointer border rounded-md p-3 flex flex-col items-center w-32 ${
                    paymentGateway === item.value
                      ? "border-green-600 bg-green-50"
                      : "border-gray-300"
                  }`}
                >
                  <input
                    type="radio"
                    name="payment"
                    value={item.value}
                    checked={paymentGateway === item.value}
                    onChange={(e) => setPaymentGateway(e.target.value)}
                    className="hidden"
                  />
                  <img
                    className="w-14 object-contain mb-2"
                    src={item.image}
                    alt={item.label}
                  />
                  <span className="text-sm font-medium">{item.label}</span>
                </label>
              ))}
            </div>
          </div>

          <div className="border bg-white rounded-md shadow-sm">
            <div className="p-5">
              <button
                onClick={handlePayment}
                disabled={processing}
                className="w-full bg-green-600 text-white font-medium py-3 rounded-md hover:bg-green-700 transition disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {processing
                  ? "Processing Payment..."
                  : `Pay with ${paymentGateway.toUpperCase()}`}
              </button>
              <p className="text-xs text-gray-500 text-center mt-3">
                By completing this payment, you agree to our terms and
                conditions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCheckout;
